module.exports = __webpack_public_path__ + "img/floor2_8.e94f934b.jpg";